<template>
  <div class="review-details" data-title="申请流程">
    <!-- 进度条 -->
    <div class="schedule-content">
      <p class="title">
        城市合伙人申请进度
      </p>
      <div class="progress-bar">
        <img src="../../assets/images/partner-img/14.png" alt="">
        <p>
          审核中
        </p>
      </div>
    </div>
    <!-- 申请人信息 -->
    <div class="applicant-information">
      <p>
        地域：{{partent_msg.region}}城市合伙人
      </p>
      <p>
        级别：{{partent_msg.level_name}}
      </p>
      <p>
        诚意金：{{partent_msg.price/10000}}万元
      </p>
      <p>
        康养积分：{{partent_msg.ky_points}}积分
      </p>
      <p>
        岗位期权：{{partent_msg.job_options}}股
      </p>
      <p>
        绩效期权：{{partent_msg.performance_options}}股
      </p>
    </div>
    <div class="order-msg">
      <p>
        订单编号：{{partent_msg.order_no}}
      </p>
      <p>
        创建时间：{{partent_msg.create_time}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      partent_msg: [],
      uid : ''
    }
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post('http://members.kfm666666.net/api/order/index/getpartner',{
      uid : this.uid
    }).then((res) => {
      console.log(res.data.data)
      this.partent_msg = res.data.data
    })
  }
}
</script>

<style lang="less" scoped>
  .review-details{
    width: 7.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // 进度
    .schedule-content{
      width: 7.1rem;
      height: 5rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      .title{
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #212121;
        margin-top: .6rem;
        margin-left: .51rem;
        line-height: .3rem;
      }
      .progress-bar{
        img{
          width: 1.43rem;
          height: 2.93rem;
          margin-top: .55rem;
          margin-left: .5rem;
          float: left;
        }
        p{
          float: right;
          margin-right: .2rem;
          margin-top: 3.23rem;
        }
      }
    }
    // 申请人信息
    .applicant-information{
      width: 7.1rem;
      height: 2.8rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      p{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #A7A7A7;
        line-height: .47rem;
        margin-left: .39rem;
      }
    }
    // 订单信息
    .order-msg{
      width: 7.1rem;
      height: 1.2rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      p{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #A7A7A7;
        line-height: .6rem;
        margin-left: .39rem;
      }
    }
  }
</style>